module.exports = __webpack_public_path__ + "static/media/car-knob.b1b92294.svg";